export * from './dlg-preferences.component';
